import { SimpleForm } from "react-admin";
import IntendedForForm from "./IntendedForForm";
import { Grid } from "@mui/material";

const StudentForm = ({ intendedFor, setIsEditIntended, record }) => {
  return (
    <Grid
      item
      xs={6}
    >
      <SimpleForm
        toolbar={false}
        defaultValue={record}
      >
        <IntendedForForm
          setIsEditIntended={setIsEditIntended}
          intendedFor={intendedFor}
        />
      </SimpleForm>
    </Grid>
  );
};
export default StudentForm;
